import { ChoicesOrder, IChoiceValueText, IChoiceWithImage } from '../types';

export const firstLetterToUpperCase = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

type ChoiceInput = string | number | IChoiceValueText | IChoiceWithImage;

export interface NormalizedChoice {
  value: string;
  text: string;
  imageLink?: string;
}

export const normalizeChoices = (
  choices: ChoiceInput[] | undefined
): NormalizedChoice[] => {
  if (!choices) return [];

  return choices.map((choice) => {
    if (typeof choice === 'string') {
      return { value: choice, text: choice };
    }
    if (typeof choice === 'number') {
      return { value: String(choice), text: String(choice) };
    }
    return {
      value: choice.value,
      text: 'text' in choice ? choice.text || choice.value : choice.value,
      imageLink: 'imageLink' in choice ? choice.imageLink : undefined,
    };
  });
};

export const reorderChoices = (
  choices: NormalizedChoice[],
  orderBy?: ChoicesOrder
): NormalizedChoice[] => {
  if (!orderBy) return choices;

  const sortedChoices = [...choices];
  switch (orderBy) {
    case ChoicesOrder.ASC:
      return sortedChoices.sort((a, b) => a.text.localeCompare(b.text));
    case ChoicesOrder.DESC:
      return sortedChoices.sort((a, b) => b.text.localeCompare(a.text));
    case ChoicesOrder.RANDOM:
      return sortedChoices.sort(() => Math.random() - 0.5);
    default:
      return sortedChoices;
  }
};

export const scrollToTop = () => {
  if (typeof window !== 'undefined') {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};
